(function () {
  if (window.__kpcReady) return;
  window.__kpcReady = true;

  var CART_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
  var CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  function getVariants(overlay) {
    var el = overlay.querySelector('.kpc-vdata');
    try { return JSON.parse(el.textContent); } catch(e) { return []; }
  }

  function getSelected(overlay) {
    var sel = {};
    overlay.querySelectorAll('.kpc-ol-btn.is-active').forEach(function(b) {
      sel[parseInt(b.dataset.pos, 10)] = b.dataset.val;
    });
    return sel;
  }

  function findMatch(variants, selected) {
    return variants.find(function(v) {
      return Object.keys(selected).every(function(p) {
        return v.options[parseInt(p,10)] === selected[p];
      });
    }) || null;
  }

  function refreshAvail(overlay, variants, selected) {
    overlay.querySelectorAll('.kpc-ol-section').forEach(function(sec) {
      var pos = parseInt(sec.dataset.optionPos, 10);
      sec.querySelectorAll('.kpc-ol-btn').forEach(function(btn) {
        var test = Object.assign({}, selected);
        test[pos] = btn.dataset.val;
        var ok = variants.some(function(v) {
          return Object.keys(test).every(function(p) {
            return v.options[parseInt(p,10)] === test[p];
          }) && v.available;
        });
        btn.classList.toggle('is-unavail', !ok);
      });
    });
  }

  function refreshATC(overlay, variants, selected) {
    var atc = overlay.querySelector('.kpc-atc');
    if (!atc) return;
    var match = findMatch(variants, selected);
    if (!match) return;
    atc.dataset.variantId = match.id;
    atc.disabled = !match.available;
    atc.innerHTML = match.available
      ? CART_SVG + ' Add to Cart'
      : 'Sold Out';
  }

  document.addEventListener('click', function(e) {

    /* Option button */
    var optBtn = e.target.closest('.kpc-ol-btn');
    if (optBtn) {
      e.preventDefault();
      var overlay = optBtn.closest('.kpc-overlay');
      if (!overlay) return;
      var pos = optBtn.dataset.pos;
      overlay.querySelectorAll('.kpc-ol-btn[data-pos="' + pos + '"]').forEach(function(b) {
        b.classList.remove('is-active');
      });
      optBtn.classList.add('is-active');
      var v = getVariants(overlay), s = getSelected(overlay);
      refreshAvail(overlay, v, s);
      refreshATC(overlay, v, s);
      return;
    }

    /* ATC button */
    var atcBtn = e.target.closest('.kpc-atc');
    if (atcBtn && !atcBtn.disabled) {
      e.preventDefault(); e.stopPropagation();
      var vid = atcBtn.dataset.variantId;
      if (!vid) return;
      var orig = atcBtn.innerHTML;
      atcBtn.disabled = true;

      var cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var sectionsToRender = (cartUI && typeof cartUI.getSectionsToRender === 'function')
        ? cartUI.getSectionsToRender().map(function (s) { return s.id; })
        : ['cart-icon-bubble'];

      fetch((window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: +vid,
          quantity: 1,
          sections: sectionsToRender,
          sections_url: window.location.pathname
        })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        atcBtn.classList.add('is-done');
        atcBtn.innerHTML = CHECK_SVG + ' Added!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        if (!cartUI) {
          console.warn('[kpc-card] No <cart-drawer> or <cart-notification> element found on this page.');
        } else if (!data.sections) {
          console.warn('[kpc-card] /cart/add.js response had no "sections" key \u2014 requested ids:', sectionsToRender, 'full response:', data);
        } else if (typeof cartUI.renderContents === 'function') {
          try {
            cartUI.renderContents(data);
          } catch (err) {
            console.error('[kpc-card] renderContents() threw:', err, data);
          }
        }

        setTimeout(function() {
          atcBtn.classList.remove('is-done');
          atcBtn.innerHTML = orig;
          atcBtn.disabled = false;
        }, 2500);
      })
      .catch(function(err) {
        console.error('[kpc-card] add to cart request failed:', err);
        atcBtn.disabled = false;
        atcBtn.innerHTML = orig;
      });
      return;
    }

    /* Touch: tap image area to toggle overlay */
    var imgWrap = e.target.closest('.kpc-img-wrap');
    if (imgWrap && !optBtn && !atcBtn) {
      if (!window.matchMedia('(hover: none)').matches) return;
      var ov = imgWrap.querySelector('.kpc-overlay');
      if (!ov) return;
      document.querySelectorAll('.kpc-overlay.is-open').forEach(function(o) {
        if (o !== ov) o.classList.remove('is-open');
      });
      ov.classList.toggle('is-open');
    }
  });

})();
